import { FC } from 'react';
import { useTranslate } from 'hooks/useTranslate';

import { HistoryMovement } from 'types';

import { ColumnCell } from 'modules/_shared/Table/types/ColumnCell';
import TableHeader from 'modules/_shared/Table/components/TableHeader';
import movementTypes from 'modules/transactions/constants/movementTypes';

import { useHistoryMovementsView } from '../../context/HistoryMovementsViewContext';
import ExpandButton from '../ExpandButton';

const RenumerationTableHeader: FC = () => {
  const { t } = useTranslate();

  const { data, actions } = useHistoryMovementsView();

  const movements = data.historyMovements ?? [];

  const isEveryMovementOfType = (type: string) =>
    movements.length > 0 &&
    movements.every(
      (movement: HistoryMovement) => movement.movementType === type
    );

  const isEntireClass = isEveryMovementOfType(
    movementTypes.ENTIRE_CLASS_RENUMERATION
  );

  const isAutomatic = isEveryMovementOfType(
    movementTypes.AUTOMATIC_RENUMERATION
  );

  const actionColumn = {
    key: 'action',
    content: (
      <ExpandButton
        onClick={actions.handleChangeExpandView}
        expandDirection={data.expandDirection}
      />
    ),
    textPosition: 'right',
  };

  const automaticColumns = [
    { key: 'scope', content: t('Scope'), textPosition: 'left' },

    { key: 'result', content: t('Result'), textPosition: 'left' },

    actionColumn,
  ];

  const entireClassColumns = [
    { key: 'scope', content: t('Scope'), textPosition: 'left' },

    { key: 'result', content: t('Result'), textPosition: 'left' },

    { key: 'class', content: t('Class'), textPosition: 'left' },

    actionColumn,
  ];

  const defaultColumns = [
    { key: 'from', content: t('From'), textPosition: 'right' },

    { key: 'to', content: t('To'), textPosition: 'right' },

    { key: 'newFrom', content: t('NewFrom'), textPosition: 'right' },

    { key: 'newTo', content: t('NewTo'), textPosition: 'right' },

    { key: 'class', content: t('Class'), textPosition: 'center' },

    actionColumn,
  ];

  const getColumns = () => {
    if (isAutomatic) return automaticColumns;
    if (isEntireClass) return entireClassColumns;
    return defaultColumns;
  };

  const columns = getColumns().filter(Boolean) as ColumnCell[];

  return <TableHeader columns={columns} />;
};

export default RenumerationTableHeader;
